import { com } from '@eidu/form'
import React from 'react'
import { Card, Stack, Typography } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import EntityTypeField from '../../pages/permission/path/EntityTypeField'
import ConfirmationDialog from '../feedback/ConfirmationDialog'
import ComplexPathField from './ComplexPathField'
import useRenderablePaths from '../misc/useRenderablePaths'
import EntityPath = com.eidu.sharedlib.entity.path.EntityPath
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import SemanticLinkId = com.eidu.sharedlib.entity.analytics.SemanticLinkId
import SemanticLinkKeyConfiguration = com.eidu.sharedlib.entity.analytics.SemanticLinkKeyConfiguration
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

type SemanticLinkItemProps = {
  linkId: SemanticLinkId
  path: EntityPath
  entityTypeId: EntityTypeId
  entityTypes: readonly EntityType[]
  semanticLinkKeyConfiguration: SemanticLinkKeyConfiguration
  onDelete?: (semanticLinkId: SemanticLinkId) => Promise<void>
}

const SemanticLinkItem = ({
  linkId,
  path,
  entityTypes,
  entityTypeId,
  semanticLinkKeyConfiguration,
  onDelete,
}: SemanticLinkItemProps) => {
  const edges = path?.edges.asJsReadonlyArrayView()
  const lastEdge = edges.at(-1)
  const targetTypeId = lastEdge?.nextType

  const targetType = targetTypeId && entityTypes.find(({ id }) => id.equals(targetTypeId))

  const renderablePaths = useRenderablePaths(entityTypeId, targetType, entityTypes)

  return (
    <Card key={linkId.toString()}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {targetType ? (
          <Stack padding={2} spacing={2}>
            <EntityTypeField
              entityTypeId={targetType.id}
              onChange={() => {}}
              types={entityTypes}
              label="Target type"
              disabled
            />
            <ComplexPathField
              entityTypeId={entityTypeId}
              targetType={targetType}
              selectedPath={path}
              setSelectedPath={() => {}}
              renderablePaths={renderablePaths}
              semanticLinkKeyConfiguration={semanticLinkKeyConfiguration}
              disabled
            />
          </Stack>
        ) : (
          <Typography padding={1} color="error">
            The configuration for this semantic link is not available. Please delete and re-create or contact your admin
          </Typography>
        )}
        {onDelete && (
          <ConfirmationDialog
            title="Are you sure you want to delete this link? This action cannot be undone."
            content={<DeleteOutlineIcon />}
            onConfirm={() => onDelete(linkId)}
          />
        )}
      </Stack>
    </Card>
  )
}

export default SemanticLinkItem
